import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class BreadcrumbActionsService {
  private activatedStateSubject = new BehaviorSubject<boolean>(false);
  private submitSubject = new Subject<void>();
  private backSubject = new Subject<void>();

  public activated$ = this.activatedStateSubject.asObservable();
  public back$ = this.backSubject.asObservable();
  public submit$ = this.submitSubject.asObservable();

  public triggerBack() {
    this.backSubject.next();
  }

  public triggerSubmit() {
    this.submitSubject.next();
  }

  public setActivatedState(value: boolean) {
    this.activatedStateSubject.next(value);
  }
}
